// API Configuration
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8001'
  },
  staging: {
    baseURL: 'https://staging-api.liaa.ai'
  },
  production: {
    baseURL: 'https://api.liaa.ai'
  }
};

// Get environment from React environment variables
const reactEnv = process.env.REACT_APP_ENVIRONMENT || 'development';
const reactApiUrl = process.env.REACT_APP_API_BASE_URL;

// Check if we're running in production based on hostname
const isProduction = 
  reactEnv === 'production' ||
  (typeof window !== 'undefined' && 
   (window.location.hostname === 'liaa.ai' || window.location.hostname === 'www.liaa.ai'));

const isStaging = 
  reactEnv === 'staging' ||
  (typeof window !== 'undefined' && 
   (window.location.hostname === 'staging.liaa.ai'));

let environment = 'development';
if (isProduction) environment = 'production';
else if (isStaging) environment = 'staging';

export const API_BASE_URL = reactApiUrl || API_CONFIG[environment as keyof typeof API_CONFIG].baseURL;

// Export environment utilities
export const ENVIRONMENT = environment;
export const IS_DEVELOPMENT = environment === 'development';
export const IS_STAGING = environment === 'staging';
export const IS_PRODUCTION = environment === 'production';

export default API_BASE_URL;
